:host {
  --icon-size: 20px;
  --active-color: gold;
  --inactive-color: #ddd;
  --spacing: 0px;
  --_icon: var(
    --icon,
    url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='2 2 20 19.02'><path d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'/></svg>")
  );

  display: inline-flex;
  align-items: center;
}

/* — Read-only mode — */

.rating {
  height: var(--icon-size);
  background: linear-gradient(
    to right,
    var(--active-color) var(--_fill, 0%),
    var(--inactive-color) var(--_fill, 0%)
  );
  mask-size: var(--icon-size) var(--icon-size);
  mask-repeat: no-repeat;
}

/* — Edit mode — */

.rating-edit {
  display: inline-flex;
  gap: var(--spacing);
}

.icon-wrapper {
  cursor: pointer;
}

.icon-wrapper input {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.icon {
  display: block;
  width: var(--icon-size);
  height: var(--icon-size);
  mask-image: var(--_icon);
  mask-size: contain;
  mask-repeat: no-repeat;
  background: var(--inactive-color);
  transition: scale 0.2s ease;
  pointer-events: none;
}

.icon.active {
  background: var(--active-color);
}

.icon-wrapper:hover .icon {
  scale: 1.2;
}

.icon-wrapper:has(input:focus-visible) .icon {
  outline: 2px solid var(--active-color);
  outline-offset: 2px;
  border-radius: 2px;
}

:host([edit-mode]) .wrapper:focus-within {
  outline: 2px solid var(--active-color);
  outline-offset: 2px;
  border-radius: 2px;
}

/* — Disabled — */

:host([disabled]) {
  opacity: 0.5;
  pointer-events: none;
}

/* — Label — */

.wrapper {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.rating-label {
  margin-inline-start: 8px;
  flex: 1;
  font-size: 1rem;
  line-height: 1;
}
